import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasGarage = createSelector(selectJsonQuery, jsonQuery => getTermValue('garage')(jsonQuery));
